import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { PLACE_CAT, placeCredit, placeImage, thumb } from "@/lib/meta";
import { PhotoCredit } from "@/components/PhotoCredit";

export const PlaceCard = ({ place, className = "", tall = false }) => {
  const src = placeImage(place);
  return (
    <div className={`flex flex-col ${className}`}>
      <Link to={`/orte/${place.id}`} data-testid={`place-card-${place.id}`}
        className={`no-photo group relative block flex-1 overflow-hidden bg-ocean ${tall ? "min-h-[420px]" : "min-h-[280px]"}`}>
        {src && <img src={thumb(src, tall ? 960 : 500)} alt={place.name} loading="lazy" className="img-tint absolute inset-0 h-full w-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent" />
        {place.open_now && (
          <span className="absolute right-4 top-4 flex items-center gap-1.5 bg-white/90 px-2 py-1 font-sub text-xs text-[#3F5E45] backdrop-blur" data-testid={`place-open-${place.id}`}>
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#3F5E45]" /> Geöffnet
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 p-6 text-white">
          <span className="eyebrow inline-block px-2 py-1 text-white" style={{ background: PLACE_CAT[place.category]?.color }}>
            {PLACE_CAT[place.category]?.label}
          </span>
          <h3 className={`mt-3 font-display leading-tight ${tall ? "text-3xl md:text-4xl" : "text-2xl"}`}>{place.name}</h3>
          <p className="mt-2 flex items-center gap-1.5 text-sm text-white/80"><MapPin size={14} strokeWidth={1.5} />{place.region}</p>
          {tall && <p className="mt-3 max-w-md text-sm leading-relaxed text-white/85">{place.summary}</p>}
        </div>
      </Link>
      {src && <PhotoCredit credit={placeCredit(place)} className="mt-1.5" testid={`place-credit-${place.id}`} />}
    </div>
  );
};
